import { Component, EventEmitter, Input, OnDestroy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngxs/store';
import { NGXLogger } from 'ngx-logger';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { ContactPerson } from 'src/app/models/ContactPerson';
import { FetchPartners } from 'src/app/partners/partners.actions';

import { DeleteContactPerson } from '../contacts.actions';

@Component({
    selector: 'app-contactperson-delete-modal',
    templateUrl: './contactperson-delete-modal.component.html',
    styleUrls: ['./contactperson-delete-modal.component.scss'],
})
export class ContactpersonDeleteModalComponent implements OnDestroy {
    private subscriptions = new Subscription();

    @Input() contactPerson: ContactPerson;

    public closeEvent: EventEmitter<void> = new EventEmitter();

    constructor(public activeModal: NgbActiveModal, private store: Store, private toastr: ToastrService, private logger: NGXLogger) {}

    deleteContactPerson() {
        this.logger.debug('Attempt to delete contactperson');
        this.subscriptions.add(
            this.store.dispatch(new DeleteContactPerson(this.contactPerson.uuid)).subscribe(
                () => {
                    this.logger.debug('Succesfully deleted contactperson');
                    this.toastr.success('Employee removed successfully');
                    this.store.dispatch(new FetchPartners()).subscribe();
                    this.closeEvent.emit();
                    this.activeModal.close();
                },
                () => {
                    this.logger.error('contactperson could not be deleted');
                },
            ),
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
